<template lang="pug">
._content-width
  section._two-column-section._fade-in
    div 
      .section-title
        h2 background
        p._title Funding is important part of Affirm’s business 
      p Affirm provide consumer pay over time options when purchase product on merchant’s website. But we can't lending money from VC directly to users, because it's very expensive and it’s not enough to growoing large volume. 
      p We sell our loans or borrow more money from investors. Capital Market team is ensuring this process is happening smoothly and make sure we have enough money to run our business.
    .image-container
      img(src="@/assets/investor-analytics-dashboard/process.png")

  section._two-column-section._fade-in
    .section-title
      h2 problem
      p._title There is no easy way to track investor’s portfolio performance
      p._text The only record the team has is weekly report that is generated by our funding system. We’ve noticed users have to pull out two recent report and put them side by side to understand the trend.
    .image-container
      img(src="@/assets/investor-analytics-dashboard/paper.png")
      p._caption Users have to pull out two recent report and put them side by side to understand the trend.

  section._fade-in
    .section-title
      h2 user research
      p._title What are the information you would like to check daily?
      p._text Designing for an expert user group I haven’t never work with is challenging, the first thing we do is to talk with different memebers on the team to understant their goals, tasks and what information do they care the most?
  ._bleeding
    img(src="@/assets/investor-analytics-dashboard/research.png")
  
  section._two-column-section._fade-in
    .section-title 
      h2 Information architecture 
      p._title How does investor dashboard fits into current system?
      p._text After learning what are the information Capital Market team needs and importance of each of them, we need understand how does this investor dashboard fit into current product - Bank Portal.  Based on the users workflow and function of other features, we finalized the high level information architecture.
    .image-container
      img(src="@/assets/investor-analytics-dashboard/ia.png")

  section._fade-in
    .section-title
      h2 wireframes
      p._title Starting wireframes with real data
      p._text Using real data not only help with getting accurate user feedback but also help understanding the spacing constraints. 
    ._grid.-default-3
      img(src="@/assets/investor-analytics-dashboard/wireframe1.png")
      img(src="@/assets/investor-analytics-dashboard/wireframe2.png")
      img(src="@/assets/investor-analytics-dashboard/wireframe3.png")
  
  section._fade-in
    .section-title
      h2 1st iteration
      p._title Mini chart to help users learn the trend
      p._text After some quick explorations, we quickly land on our first draft. We learned from user research that users need to understand the trend of different metrics to be well prepared. Our 1st draft features on using mini chart to help users understand the trend.
    ._grid.-default-2
      img(src="@/assets/investor-analytics-dashboard/mini1.png")
      img(src="@/assets/investor-analytics-dashboard/mini2.png")
      
  section._two-column-section._fade-in
    div
      .section-title
        h2 testing
        p._title “I can’t tell the scale of the mini chart without any numbers”
        p._text We conducted user testing with 6 people on Captial Market team using the 1st draft.  We will allow users to click around and ask them what information they can learn from different section. We also use this opportunity to learn if there is anything critical that is missing.
      ul
        li._icon-list(v-for="item in TESTING")
          img(:src="item.icon")
          | {{item.text}}
    .image-container
      img(src="@/assets/investor-analytics-dashboard/testing.png")
      p._caption Users have to pull out two recent report and put them side by side to understand the trend.

  section._fade-in
    .section-title
      h2 iterations
      p._title Our users are experts on numbers
      p._text Through 1st round of testing, we learned that our users are experts on numbers. Taking out the raw data and reaching to interpret for them actually make it less efficient for users. With the in mind, we did several explorations and iterations. Here are two of the examples:
    ._card.-container-card._fade-in(v-for="(part, partIndex) in ITERATIONS")
      p: span._tag(:class="{[`-tag-${partIndex + 1}`]: true}") {{part.tag}}
      h3 {{part.title}}
      p {{part.text}}
      ._grid.-default-2
        .option(v-for="(option, optionIndex) in part.options")
          img(:src="option.image", :class="{[`-selected-${partIndex + 1}`]: optionIndex === 0}")
          p.image-title {{option.title}}
          p {{option.text}}
  
  section._fade-in
    .section-title
      h2 final design
      p._title final design
    
    ._grid.-default-2
      .-whole-row
        h3 Overview page
        p This page helps users to take a glance of the investor’s loan performance and catch alerts
        img(src="@/assets/investor-analytics-dashboard/final1.png")
      div
        h3 Concemtration
        p Monitor current concentration data, both short term and long term trend
        img(src="@/assets/investor-analytics-dashboard/final2.png")
      div
        h3 Concemtration detail
        p Explore and understand historical detail information on each concentration
        img(src="@/assets/investor-analytics-dashboard/final3.png")
      .-whole-row
        h3 Sales history
        p A record of all sales history that happened to this investor. It serves the need for any trouble shooting and analysis
        img(src="@/assets/investor-analytics-dashboard/final4.png")
      .-whole-row
        h3 Mission Control
        p The homepage for funding that helps user understand how much capacity to fund our loans across all investors
        img(src="@/assets/investor-analytics-dashboard/final5.png")
  
  section._fade-in
    .section-title
      h2 impact
      p._title A tools used by Capital Market team daily 
      p._text The Eng team successfully launched the project in Nov 2019 since then the investor dashboard has been a tool Capital Market team review daily. It is also adopted by Affirm’s Exc teams to monitor and understand the healthy of Affirm’s funding. 
    p._quote The first thing I do every morning is to spend 5-10 minutes checking all the investors I work with. The real time trending really help us manage our risk more efficiently
</template>

<script>
export default {
  data() {
    return {
      TESTING: [
        {text: 'Hard to tell the scale of the mini chart without any numbers', icon: require('@/assets/investor-analytics-dashboard/icon-chart.png')},
        {text: 'Flag alert on any metrics that is close to limit or need attention', icon: require('@/assets/investor-analytics-dashboard/icon-warning.png')},
        {text: 'On top level, understand how much funcing capacity we have is the most important thing', icon: require('@/assets/investor-analytics-dashboard/icon-battery.png')},
      ],
      ITERATIONS: [
        {tag: 'Exmaple 1', title: 'How to infor users the trend of each metrics?', text: 'We learned from user testing that it’s hard to tell the scale of the mini chart without any numbers, so what are other ways to inform users the trend and how should we using the numbers more?', options: [
          {image: require('@/assets/investor-analytics-dashboard/example1-1.png'), title: '1st iteration - 30, 60, 90 Day', text: 'Directly show users the data of last 30, 60 and 90 day so that users know how the number is trending, it does the job but not very efficient'},
          {image: require('@/assets/investor-analytics-dashboard/example1-2.png'), title: '2nd iteration - 30, 60, 90 Day with background chart', text: 'We want to use the background chart as a quick way to help users understand the trend. But when we apply it with real data, it’s very hard to notice the change.'},
          {image: require('@/assets/investor-analytics-dashboard/example1-3.png'), title: '3rd iteration - 90 Day change ', text: 'Using 90 day change as a way to measure the trend helps users identify any major changes fast. But we learned from user testing that, users also want to understand a short term change'},
          {image: require('@/assets/investor-analytics-dashboard/example1-4.png'), title: '4th iteration - 30, 90 Day change ', text: 'Having both 30, and 90 day change as a way to measer both short term as well as long term trends is very helpful for users. We also made several visual tweak like minimize “%”, moving alert icon next to number, using black for change as ways to help user easily identify alert when there is any'},
        ]},
        {tag: 'Exmaple 2', title: 'How might the overview page help user understand investor’s perfomance with a glance?', text: 'The overview page recieved positive feedback in our testing. We learned information users is looking for is, alert if there is any, balance, advanced rate and the most recent sale (ranking with importance). ', options: [
          {image: require('@/assets/investor-analytics-dashboard/example2-1.png'), title: 'Card', text: 'The card visual really resonate a lot with users as well as PM and Engineers as it provides a feel of dashboard and modularize section provide flexibility for furture features. But having to scroll down to see the alerts is not efficient. '},
          {image: require('@/assets/investor-analytics-dashboard/example2-2.png'), title: 'Single column', text: 'The visual treatment for alert section doesn’t drive urgency to users. But users really like that the two chart are aligned vertically, so that it’s easy for them to compare and understand the correlation between them.'},
          {image: require('@/assets/investor-analytics-dashboard/example2-3.png'), title: 'Alert center', text: 'Users really resonate with the alerts on the right hand side because it folllows the common alert center design pattern. When there is an alert, users can notice it easily but won’t be distracted by it if there isn’t any alert'},
          {image: require('@/assets/investor-analytics-dashboard/example2-4.png'), title: 'Final - Put everthing together', text: 'We take all the feedback recieved on the explorations and encoporated them into the final design, a dashboard with alert center on the right hand side.'},
        ]},
      ],
    };
  },
}
</script>

<style lang="scss" scoped>
@import 'project.scss';
</style>
